import React from 'react';

const CARD_IMG = '/Images/News/claude-logo-hero.png';

const ClaudeFable5 = () => (
  <>
    <figure className="news-article-figure news-article-figure--hero news-article-figure--editorial">
      <img
        src={CARD_IMG}
        alt="Claude logo on a cream editorial panel for the Fable 5 launch and access suspension."
        loading="lazy"
        decoding="async"
      />
      <figcaption>
        Claude Fable 5: Anthropic&apos;s Mythos-class frontier model — launched June 9, 2026,
        suspended June 12, 2026.
      </figcaption>
    </figure>

    <article className="news-article-body">
      <p className="news-lead">
        On June 9, 2026, Anthropic released Claude Fable 5 — its most capable model ever made
        widely available. Three days later, on June 12, the company suspended access to Fable 5
        and Mythos 5 for all users worldwide, following a US government export-control directive.
        Other Claude models, including Opus, remain available.
      </p>

      <h2>What launched on June 9</h2>
      <p>
        Fable 5 is Anthropic&apos;s first <strong>Mythos-class</strong> model safe for general use.
        It leads on software engineering, long-horizon agent work, vision, and knowledge tasks —
        with stronger token efficiency than earlier Claude generations on comparable jobs.
      </p>
      <ul>
        <li>
          <strong>Fable 5</strong> — public release with built-in safeguards. Some sensitive
          queries route to Claude Opus 4.8 instead (under ~5% of sessions at launch).
        </li>
        <li>
          <strong>Mythos 5</strong> — same core model, fewer restrictions, limited to Project
          Glasswing partners for defensive cybersecurity work.
        </li>
        <li>
          <strong>Pricing</strong> — $10 per million input tokens, $50 per million output
          tokens — less than half the cost of Mythos Preview.
        </li>
        <li>
          <strong>Availability</strong> — Claude API, Amazon Bedrock, Vertex AI, Microsoft
          Foundry, and subscription plans (Pro, Max, Team, Enterprise).
        </li>
      </ul>

      <h2>What happened on June 12</h2>
      <p>
        Anthropic received a government directive at 5:21pm ET citing national security
        authorities. The concern: a narrow, non-universal jailbreak technique that could elicit
        some cybersecurity-related output. Anthropic says the capability shown is comparable to
        other publicly available frontier models — but to comply, it had to disable Fable 5 and
        Mythos 5 for <em>everyone</em>, including foreign nationals inside the US.
      </p>
      <p>
        AWS, Google Cloud, and other partners updated their platforms the same day. Anthropic
        apologised for the disruption and said it is working to restore access. No timeline has
        been announced.
      </p>

      <h2>Why it matters for enterprise teams</h2>
      <p>
        Fable 5 landed at a moment when teams were already planning around frontier coding and
        agent pipelines. The sudden pull creates real planning friction — but it also highlights
        a pattern: the most capable models now ship with layered safeguards, government
        oversight, and the risk of rapid recall.
      </p>
      <p>
        For production workloads, the practical takeaway is to design around model availability:
        keep fallbacks, abstract the model layer, and do not hard-code a three-day-old frontier
        release into a launch-critical path.
      </p>

      <div className="news-insight-box">
        <h3>The Ewands view</h3>
        <p>
          We tested Fable 5 in the brief window before suspension. Our take, from an enterprise
          buyer&apos;s seat: <strong>strong reasoning IQ</strong> — clearly a step up on complex
          coding and multi-step analysis. There is a little murmur from the conservative
          safeguards (occasional false positives on harmless prompts), but with minor prompt
          tweaks it performs very well. <strong>Token efficiency sits in the medium range</strong>
          — better than older Claude tiers on long tasks, though not as lean as some rivals on
          short turns. Worth watching when access returns; not something we would bet a
          go-live date on today.
        </p>
      </div>
    </article>
  </>
);

export default ClaudeFable5;
